'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import getCurrentStepName from '@haaretz/s-pp-routing-utils/getCurrentStepName';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React from 'react';
export default function TaboolaPixel() {
    const router = useRouter();
    const currentStepName = getCurrentStepName(router.pathname);
    const prevStepRef = React.useRef(currentStepName);
    React.useEffect(()=>{
        if (currentStepName && currentStepName !== prevStepRef.current) {
            window._tfa = window._tfa || [];
            window._tfa.push({
                notify: 'newPageLoad'
            });
            prevStepRef.current = currentStepName;
        }
    }, [
        currentStepName,
        router.pathname
    ]);
    return /*#__PURE__*/ _jsx(Script, {
        id: "taboola-pixel",
        strategy: "beforeInteractive",
        dangerouslySetInnerHTML: {
            __html: `
      window._tfa = window._tfa || [];
      window._tfa.push({notify: 'event', name: 'page_view', id: 1063110});
      !function (t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
        }
      }(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      '//cdn.taboola.com/libtrc/unip/1063110/tfa.js',
      'tb_tfa_script');
    `
        }
    });
}

//# sourceMappingURL=TaboolaPixel.js.map